module.exports = __webpack_public_path__ + "static/media/BackonLogoWhite.d4abf26f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Icons/BackonLogoWhite.svg
// module id = 232
// module chunks = 0